export default __webpack_public_path__ + "static/FaceCloak-213956456b40412434f90bc496e721d5.mp4";